module.exports = __webpack_public_path__ + "static/media/tutorial-banner-pin.892e2f76.svg";